import SaleTable from '../saleTable/SaleTable.vue';

export default {
  name: 'AddSale',
  components: { SaleTable },
  props: ['action_id', 'id'],
  data() {
    return {
      saleID: this.$props.id,
      actionID: this.$props.action_id,
      type: 'individual',
      valid: false,
      product: null,
      quantity: null,
      productsList: [],
      isLoading: false,
      dealer: null,
      address: null,
      allowedStatuses: ['checked', 'approved'],
      newSale: {
        action_id: +this.$props.action_id,
        dealer_id: null,
        address_id: null,
        positions: [],
      },
      rules: {
        // required: v => !!v || 'Поле должно быть заполнено',
        min: v => (!v || v >= 1) || 'Минимальное кол-во 1',
      },
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    action() { return this.$store.state.sales.action; },
    loading() { return this.$store.state.loading; },
    products() {
      const { action } = this.$store.state.sales;
      return (action !== null) ? action.products : [];
    },
    allowedAddresses() {
      if (!this.dealer) return [];
      return this.dealer.addresses.filter(a => this.IsRegionAllowed(a.region_id));
    },
    canSubmit() {
      // eslint-disable-next-line
      const { action_id, dealer_id, address_id, positions } = this.newSale;
      // eslint-disable-next-line
      return action_id && dealer_id && address_id && positions.length;
    },
  },
  methods: {
    SetUniqueId() {
      return (new Date()).getTime();
    },
    IsRegionAllowed(regionId) {
      // eslint-disable-next-line
      const { region_ids = [], excluded_region_ids = [] } = this.action || {};
      if (regionId === undefined) return true;
      const id = +regionId;
      if (region_ids.length && !region_ids.includes(id)) return false;
      return !excluded_region_ids.includes(id);
    },
    HasAllowedAddress(profileDealer) {
      return profileDealer.addresses
        ? profileDealer.addresses.some(a => this.IsRegionAllowed(a.region_id))
        : true;
    },
    SetDealer(val) {
      this.newSale.dealer_id = val.dealer_id;
    },
    SetAddress(val) {
      this.newSale.address_id = val.id;
    },
    AddProduct() {
      this.newSale.positions.push({
        listID: this.SetUniqueId().toString(),
        product_id: this.product.id,
        name: this.product.name,
        quantity: +this.quantity,
      });
      this.product = null;
      this.quantity = null;
    },
    DeleteProduct(listID) {
      this.newSale.positions = this.newSale.positions.filter(item => item.listID !== listID);
    },
    ChangePosition(listID) {
      const position = this.newSale.positions.find(item => item.listID === listID);
      this.DeleteProduct(listID);
      this.product = this.products.find(item => item.id === position.product_id);
      this.quantity = position.quantity;
    },
    PreloadSale(data) {
      if (data) {
        console.log(data);
        this.type = data.type;
        const positions = data.positions.map((p, idx) => ({
          ...p,
          name: p.product.name,
          listID: `${this.SetUniqueId().toString()}${p.product.id}${idx}`,
        }));
        const dealer = this.user.profiles_dealers.find(d => d.dealer_id === data.dealer.id);
        this.dealer = dealer || null;
        this.address = data.dealerAddress;
        this.newSale = {
          dealer_id: data.dealer_id,
          positions,
          address_id: data.dealerAddress.id,
          action_id: data.action_id,
        };
      }
    },
    OnSubmit() {
      const app = this;
      const url = this.saleID !== 'null' ? 'sales/api/sale/update' : 'sales/api/sale/create';
      const payload = {
        ...app.newSale,
        profile_id: app.user.profile_id,
      };

      if (this.saleID !== 'null') {
        payload.sale_id = +this.saleID;
      }

      app.$store.getters.axl.post(url, payload)
        .then(() => {
          app.$router.push('/sales/');
          app.$store.dispatch('ShowInfo', 'Продажа отправлена на проверку');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  created() {
    if (this.actionID !== 'null') {
      this.$store.dispatch('sales/GetAction', {
        action_id: +this.actionID,
      });
    }
  },
  mounted() {
    const app = this;
    if (app.saleID !== 'null') {
      app.$store.dispatch('sales/GetSale', {
        profile_id: app.user.profile_id,
        sale_id: +app.saleID,
      })
        .then((data) => {
          app.PreloadSale(data.sale);
        });
    }
  },
};
